import styled from 'styled-components';
import { Banner } from 'ui/banner';
import { spacing } from 'ui/theme';

export const StyledBanner = styled(Banner)`
  margin-top: ${spacing.half};
`;

export const SelectWrapper = styled.div`
  > div {
    width: 100%;

    > div {
      width: 100%;
    }
  }
`;
